import { render, staticRenderFns } from "./PendingMovements.vue?vue&type=template&id=e89fdfdc&scoped=true"
import script from "./PendingMovements.vue?vue&type=script&lang=js"
export * from "./PendingMovements.vue?vue&type=script&lang=js"
import style0 from "./PendingMovements.vue?vue&type=style&index=0&id=e89fdfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89fdfdc",
  null
  
)

export default component.exports